module.exports = __webpack_public_path__ + "pg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pg.svg
// module id = 754
// module chunks = 0